import type { Patron } from "../types";

type RetainSelectedPatronsArgs = {
  availablePatrons: Patron[];
  selectedPatrons: Patron[];
  selectedPlayerIds: string[];
  shouldRetainSelectedPatrons: boolean;
};

export const retainSelectedPatrons = ({
  availablePatrons,
  selectedPatrons,
  selectedPlayerIds,
  shouldRetainSelectedPatrons,
}: RetainSelectedPatronsArgs): Patron[] => {
  const retainedPatrons = shouldRetainSelectedPatrons
    ? selectedPatrons.filter(
        (patron) =>
          patron.playerId && selectedPlayerIds.includes(patron.playerId)
      )
    : [];
  const seenPlayerIds = new Set<string>();
  const patrons = [...retainedPatrons, ...availablePatrons].filter((patron) => {
    if (!patron.playerId || seenPlayerIds.has(patron.playerId)) return false;

    seenPlayerIds.add(patron.playerId);
    return true;
  });

  if (!shouldRetainSelectedPatrons) return patrons;

  return patrons.slice().sort((firstPatron, secondPatron) => {
    const firstIsSelected = selectedPlayerIds.includes(
      firstPatron.playerId ?? ""
    );
    const secondIsSelected = selectedPlayerIds.includes(
      secondPatron.playerId ?? ""
    );

    if (firstIsSelected === secondIsSelected) return 0;
    return firstIsSelected ? -1 : 1;
  });
};
